export const errorMessage = `
    <div class="c-map-error c-col-text-area">
    <p>There was an error in obtaining map data.</p>
    <p>Please find event information at the following links:</p>
    <ul>
        <li><a class="c-cta" href="${window.location.origin}/whats-on-by-venue">What's on by venue</a>
        <li><a class="c-cta" href="${window.location.origin}/whats-on-by-film">What's on by film</a>
    </ul>
    </div>
`
